import  genericComponents from '../../Actions/_GenericComponents';
import { find, add, generic, deleteItem } from '../../helpers';
const { types } = genericComponents;

const initialState = {   
    loading: {
        isCurrentlyLoading: false,
        loadingArray: [],
        find: function(id) {
            return find(id, this.loadingArray)
        }
    },
    stickyNotes: {
        items:[],
        find: function(id) {
            return find(id, this.items);
        },
    },
};

const genericComponentsReducer = (state = initialState, action) => {   
    let newState;
    switch(action.type) {       
        case types.GENERIC_APP_LOADING:
            return isLoading(state, action);
        case types.ADD_STICKY_NOTE:
            newState = generic(state, add(action.data, state.stickyNotes.items), 'stickyNotes');
            return newState;
        case types.REMOVE_STICKY_NOTE:
            newState = generic(state, deleteItem(action.data.id, state.stickyNotes.items), 'stickyNotes');
            return newState;
        default:
            return state;
    }
}


const isLoading = (state, action) => {
    let { isLoading, id } = action;
    let { loadingArray } = state.loading;

    let loading = {
        isCurrentlyLoading:false,
        loadingArray: []
    }

    if(id && !isLoading) {
        let index = loadingArray.findIndex(item => {
            return item.id === id;
        });

        if (index >= 0) {
            loading.loadingArray = [
                ...loadingArray.slice(0, index),
                ...loadingArray.slice(index + 1)
            ];
        }
    } else {
        loading.loadingArray = [
            ...loadingArray,
            { id, isLoading },
        ]
    }
    
    loading.isCurrentlyLoading = loading.loadingArray.length > 0;
    
    return {
        ...state,
        loading:{
            ...state.loading,
            ...loading
        }
    }
}


export default genericComponentsReducer;
